import languages from '@/lang/languages'
import { createI18n } from 'vue-i18n'

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    messages: languages
})

export default i18n
